import React from 'react';
import { FormattedDate, FormattedRelative } from 'react-intl';

import Styled from 'styled';

import defaultStyles from './registration-date.scss';
import { RegistrationDateFragment } from './registration-date.graphql';

export interface Props extends RegistrationDateFragment {
    styles: typeof defaultStyles;
}

interface State {
    dateJoined?: Date;
}

class RegistrationDate extends React.PureComponent<Props, State> {
    static getDerivedStateFromProps: React.GetDerivedStateFromProps<Props, State> = props => {
        return {
            dateJoined: props.dateJoined ? new Date(props.dateJoined) : undefined,
        };
    };

    state: State = {};

    render() {
        const { styles } = this.props;
        const { dateJoined } = this.state;

        if (!dateJoined) {
            return null;
        }

        return (
            <React.Fragment>
                <span className={styles!.date}>
                    <FormattedDate value={dateJoined} />
                </span>
                <span className={styles!.description}>
                    <FormattedRelative value={dateJoined} />
                </span>
            </React.Fragment>
        );
    }
}

export default Styled(defaultStyles)(RegistrationDate);
